module.exports = __webpack_public_path__ + "00abe0acda2b6a6bffa2f84e1602c654.fbx";